import { module } from 'angular';
import { GmcCvFilterService } from './gmc-cv-filter.service';
import { SectionFilterComponent } from './components/section-filter/section-filter.component';
import { PositionFilterComponent } from './components/position-filter/position-filter.component';
import { GmcCvFilterComponent } from './gmc-cv-filter.component';

export const GmcCvFilterModule = module('app.shared.components.gmc-cv-filter', [])
  .service(GmcCvFilterService.name, GmcCvFilterService)
  .component('gmcCvFilter', GmcCvFilterComponent)
  .component('sectionFilter', SectionFilterComponent)
  .component('positionFilter', PositionFilterComponent);



// WEBPACK FOOTER //
// ./app/shared/components/gmc-cv-filter/gmc-cv-filter.module.ts